export enum VoucherType {
  VOUCHER_CODE = 'VoucherCode',
  CARD_NUMBER = 'CardNumber',
}
